import { PartialSKU, SKUPart, SvcShowTypeEnum } from 'domains/skuDomain';
import { useSkuSvcRole } from 'hooks/useSkuSvcRole';
import './index.less';

import { Step1QuantitiesOrientation } from './Step1QuantitiesOrientation';
import { Step2Size } from './Step2Size';
import { Step3Paper } from './Step3Paper';
import { Step4Presses } from './Step4Presses';
import { Step5UploadFiles } from './Step5UploadFiles';
// import { Step5UploadFiles } from './Step5UploadFiles';
import { MutableRefObject, useMemo } from 'react';
import { Step6InkFinishes } from './Step6InkFinishes';
import { Step7JobOptions } from './Step7JobOptions';
import { Step7RequiredServices } from './Step7RequiredServices';
import { Step8AdditionalJobOptions } from './Step8AdditionalJobOptions';
import { Step8OptionalServices } from './Step8OptionalServices';
import { Step9Extra } from './Step9Extra';

type Props = {
  step: number;
  sku: PartialSKU;
  topSku?: PartialSKU;
  skuPart?: SKUPart;
};

export interface StepComponentProps {
  sku: PartialSKU;
  topSku?: PartialSKU;
  skuPart?: SKUPart;
}

export interface StepComponentSvcProps extends StepComponentProps {
  showType: SvcShowTypeEnum;
  onRef: MutableRefObject<any>;
  disabled: boolean;
  refSubmitData?: () => Promise<any>;
}

const SingleWizardStep = ({ step, sku, topSku, skuPart }: Props) => {
  const svcRole = useSkuSvcRole(sku);
  const steps = useMemo(() => {
    let returnData = [
      <Step1QuantitiesOrientation
        sku={sku}
        topSku={topSku}
        skuPart={skuPart}
      />,
      <Step2Size sku={sku} topSku={topSku} skuPart={skuPart} />,
      <Step3Paper sku={sku} topSku={topSku} skuPart={skuPart} />,
      <Step4Presses sku={sku} topSku={topSku} skuPart={skuPart} />,
      <Step5UploadFiles sku={sku} topSku={topSku} skuPart={skuPart} />,
      <Step6InkFinishes sku={sku} topSku={topSku} skuPart={skuPart} />,
    ];
    if (svcRole.isJobOption) {
      returnData.push(
        <Step7JobOptions sku={sku} topSku={topSku} skuPart={skuPart} />
      );
    }
    if (svcRole.isRequiredSvc) {
      returnData.push(
        <Step7RequiredServices sku={sku} topSku={topSku} skuPart={skuPart} />
      );
    }
    if (svcRole.isAdditionalJobOption) {
      returnData.push(
        <Step8AdditionalJobOptions
          sku={sku}
          topSku={topSku}
          skuPart={skuPart}
        />
      );
    }
    if (svcRole.isOptionalSvc) {
      returnData.push(
        <Step8OptionalServices sku={sku} topSku={topSku} skuPart={skuPart} />
      );
    }
    returnData.push(<Step9Extra sku={sku} topSku={topSku} skuPart={skuPart} />);
    return returnData;
  }, [sku, skuPart, svcRole, topSku]);

  return <div className="single-sku-config-wizard-step">{steps[step]}</div>;
};

export default SingleWizardStep;
